
        'use strict';
        import {getSessionTimeoutParams,getKeepMeSignInConfig, getChosenKeepMeSignInConf, getBackendSystem} from "../appConfig/appConfigForward";
        import { getInjectableName} from 'ng-metadata/core';
        import { StorageUtil } from "../infra/storageUtil.service";
        
        let TIMEOUT_GAP_BEFORE_SIGNOUT_DEFAULT: number = 60; // the time in seconds to allow user to keep sign-in
        let TIMEOUT_GAP_BEFORE_SIGNOUT_SHORT: number = 30; // the time in seconds to allow user to keep sign-in in case the timeout in BO set to 60 seconds 

        var angular:angular.IAngularStatic =  require('angular');
        angular.module('primo-explore.security')
            .factory('SessionTimeoutService',SessionTimeoutService);
        function SessionTimeoutService(Idle, $http, restBaseURLs, StorageUtil) {
            let service = {
                // Add your functions here
                // parseItem:parseItem
                isSessionExpired: isSessionExpired,
                startSession: startSession,
                updateSessionTimeoutTime: updateSessionTimeoutTime
            };
            return service;




            function startSession(isGuest){
                let sessionTimeoutParams = getSessionTimeoutParams();

                // For signed in user
                if (!isGuest){
                    let MAX_TIMEOUT_SESSION: number = 604800;   // 7 days in seconds = 604800
                    let AUTO_EXTEND_MY_SESSION: string = 'autoExtendMySession';
                    let chosenConf = getChosenKeepMeSignInConf();
                    let autoExtendUserSessionUserConf = StorageUtil.sessionStorage.getItem(AUTO_EXTEND_MY_SESSION) === 'true'; //Auto-extend session - user's selection
                    let autoExtendUserSessionInstConf = getKeepMeSignInConfig().isEnableUserSettingForExtendSession; //Auto-extend session - Institution's selection
                    let sessionTimeoutInSeconds = sessionTimeoutParams.userSessionTimeout * 60;
                    
                    if (autoExtendUserSessionUserConf && autoExtendUserSessionInstConf){
                        sessionTimeoutInSeconds = MAX_TIMEOUT_SESSION;

                       // For primo : update the session period also in server - when automatically extend the session is on
                        if(getBackendSystem() !== 'suprima'){
                            let dataToBeSent = { extendTime: sessionTimeoutInSeconds};
                            $http.get(restBaseURLs.extendSession, {params: dataToBeSent});
                        }
                    } 
   
                    // In order to catch and pop up 60 seconds before the session times out
                    if(chosenConf != null && (chosenConf == 'extend' || chosenConf == 'extend_max')){
                        sessionTimeoutInSeconds = (sessionTimeoutInSeconds > TIMEOUT_GAP_BEFORE_SIGNOUT_DEFAULT) ? sessionTimeoutInSeconds - TIMEOUT_GAP_BEFORE_SIGNOUT_DEFAULT : TIMEOUT_GAP_BEFORE_SIGNOUT_SHORT;
                    }
       
                    if(sessionTimeoutInSeconds && sessionTimeoutInSeconds > 0){
                        Idle.setIdle(sessionTimeoutInSeconds);
                        Idle.watch();  // Starts watching for idleness, or resets the idle/warning state and continues watching
                    }
                    return;
                }
                
                // For Guest
                let sessionTimeoutInSeconds = (isGuest? sessionTimeoutParams.guestSessionTimeout : sessionTimeoutParams.userSessionTimeout) * 60;
                if (sessionTimeoutInSeconds && sessionTimeoutInSeconds > 0){
                    Idle.setIdle(sessionTimeoutInSeconds);
                    Idle.watch();
                }
                else{
                    Idle.unwatch();
                }
            }

            function isSessionExpired() {
                return Idle.isExpired();
            }

            function updateSessionTimeoutTime(time){
                let chosenConf = getChosenKeepMeSignInConf();
                if(chosenConf != null && (chosenConf == 'extend' || chosenConf == 'extend_max')){
                    time = (time > TIMEOUT_GAP_BEFORE_SIGNOUT_DEFAULT) ? time - TIMEOUT_GAP_BEFORE_SIGNOUT_DEFAULT : TIMEOUT_GAP_BEFORE_SIGNOUT_SHORT;
                }
                if(time > 0){
                    Idle.setIdle(time);	   // Updates the idle value and restarts the watch if its running
                }  
            }

        }
        SessionTimeoutService.$inject = ['Idle','$http', 'restBaseURLs', getInjectableName(StorageUtil)];



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/sessionTimeout.service.ts